/*
 * Rinfresca il carrello del tema quando a metterci dentro qualcosa e' un'APP,
 * non il tema.
 *
 * Il problema (02/09/2026): dalla wishlist (Wishlist by Square, che sotto e'
 * Vitals) il pulsante «Aggiungi al Carrello» chiama `/cart/add.js` per conto
 * suo. Il carrello sul server cambia davvero, ma il tema non lo sa: il badge
 * in testata resta al numero vecchio e il cassetto continua a mostrare la
 * roba di prima finche' non si ricarica la pagina.
 *
 * Il tema Sleek aggiorna quelle due cose solo quando qualcuno pubblica
 * `cart-update` sul suo pubsub (vedi `cart.js`: <cart-count> e <cart-items>
 * sono abbonati la'). Vitals non lo pubblica, e non ha modo di saperlo.
 *
 * Perche' non l'evento `cart:refresh` del tema, che sembrerebbe fatto apposta:
 * il suo gestore costruisce l'indirizzo con `FoxTheme.routes.root_url`, che in
 * questo tema NON ESISTE (`FoxTheme.routes` ha solo cart_*, shop_url e
 * predictive_search_url). La chiamata parte verso «undefined?section_id=...»,
 * fallisce, e il `catch` la ingoia: l'evento c'e' ma non fa niente. Verificato
 * in vetrina il 02/09/2026.
 *
 * Quello che facciamo invece e' l'idioma che il tema usa per se' (`theme.js`,
 * ProductForm): raccogliere le sezioni da ridisegnare, chiedere a Shopify il
 * carrello con quelle sezioni gia' rese, e pubblicare `cart-update`.
 *
 * Non serve conoscere Vitals: si guarda `fetch` verso le rotte del carrello di
 * Shopify, che sono di Shopify e non cambiano. Vale quindi per qualunque app.
 */
(function () {
  'use strict';

  // Se il file finisse incluso due volte, `fetch` verrebbe avvolto due volte e
  // ogni aggiunta farebbe due giri di rinfresco.
  if (window.__ethroRinfrescoCarrello) return;
  window.__ethroRinfrescoCarrello = true;

  // Le rotte che cambiano il carrello. `/cart` da solo no: e' una lettura.
  var ROTTE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;
  // Quanto lasciamo al tema per farlo da se', quando non siamo riusciti a
  // riconoscere che la chiamata era sua.
  var ATTESA = 900;
  // Intestazione con cui marchiamo le NOSTRE chiamate, per non rincorrerle.
  // Una bandiera globale a tempo non andava bene: mentre era alzata, una
  // seconda aggiunta vera dell'app — due prodotti spostati dalla wishlist a un
  // secondo di distanza — passava inosservata, cioe' esattamente il guasto che
  // questo file esiste per chiudere.
  var SEGNALE = 'X-Ethro-Rinfresco';

  var ultimoAggiornamento = 0; // quando il tema ha pubblicato l'ultimo cart-update
  var ultimoTocco = 0; // ultima volta che la persona ha toccato la pagina

  ['click', 'touchend', 'keydown'].forEach(function (evento) {
    document.addEventListener(
      evento,
      function () {
        ultimoTocco = Date.now();
      },
      true
    );
  });

  // Il pubsub del tema nasce con `theme.js`, che e' `defer`: puo' non esserci
  // ancora quando questo file parte.
  function seguiIlTema() {
    if (!window.FoxTheme || !FoxTheme.pubsub || !FoxTheme.pubsub.PUB_SUB_EVENTS) return false;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
      ultimoAggiornamento = Date.now();
    });
    return true;
  }
  if (!seguiIlTema()) {
    var battito = setInterval(function () {
      if (seguiIlTema()) clearInterval(battito);
    }, 200);
    setTimeout(function () {
      clearInterval(battito);
    }, 15000);
  }

  // `fetch` accetta una stringa, un Request, ma anche un URL — che non ha `.url`
  // e con un `|| ''` sparirebbe dal controllo senza dare segno.
  function indirizzoDi(risorsa) {
    if (typeof risorsa === 'string') return risorsa;
    if (risorsa && typeof risorsa.url === 'string') return risorsa.url;
    return String(risorsa || '');
  }

  function nostra(risorsa, opzioni) {
    var teste = (opzioni && opzioni.headers) || (risorsa && risorsa.headers);
    if (!teste) return false;
    if (typeof teste.get === 'function') return !!teste.get(SEGNALE);
    return !!(teste[SEGNALE] || teste[SEGNALE.toLowerCase()]);
  }

  // Il tema, quando aggiunge o cambia una riga, manda un corpo JSON che contiene
  // `sections`: lo fa perche' vuole indietro le sezioni gia' rese. Le app non lo
  // fanno. Riconoscerlo qui evita di rincorrere una chiamata del tema su una
  // connessione lenta, dove il suo giro (aggiunta → carrello → pubblicazione)
  // supera tranquillamente l'attesa e ci farebbe rinfrescare per niente,
  // riaprendo il cassetto in faccia alla persona.
  function delTema(opzioni) {
    var corpo = opzioni && opzioni.body;
    return typeof corpo === 'string' && corpo.indexOf('"sections"') !== -1;
  }

  function suPaginaCarrello() {
    return /\/cart\/?$/.test(location.pathname || '');
  }

  // Le sezioni Shopify le rende nel contesto di questo indirizzo: chiedere la
  // sezione della pagina carrello mentre si dice «rendi sulla home» la fa
  // tornare vuota, e il tema — che si aspetta di trovarla — svuota la pagina.
  // La home serve solo per gli indirizzi del proxy delle app (/apps/...), che
  // pagine del tema non sono.
  function percorsoSezioni() {
    var percorso = location.pathname || '/';
    return percorso.indexOf('/apps/') === 0 ? '/' : percorso;
  }

  function rinfresca(apriIlCassetto) {
    if (!window.FoxTheme || !FoxTheme.pubsub || !FoxTheme.utils || !FoxTheme.routes) return;

    var sezioni = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sezioni } })
    );

    var sezioniRese;
    try {
      // Se sulla pagina non c'e' nessuna sezione da ridisegnare, la chiamata a
      // /cart/update sarebbe un giro a vuoto: si passa dritti al carrello. Il
      // badge si aggiorna comunque, perche' <cart-count> legge `item_count` e
      // non guarda le sezioni.
      if (!sezioni.length) {
        sezioniRese = Promise.resolve({});
      } else {
        var config = FoxTheme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers[SEGNALE] = '1';
        delete config.headers['Content-Type'];
        var modulo = new FormData();
        modulo.append('sections', sezioni);
        modulo.append('sections_url', percorsoSezioni());
        config.body = modulo;
        sezioniRese = fetch(FoxTheme.routes.cart_update_url, config)
          .then(function (r) {
            return r.json();
          })
          .then(function (stato) {
            return stato.sections || {};
          });
      }
    } catch (e) {
      // Se il tema cambiasse la forma di `fetchConfig`, qui si romperebbe tutto
      // in silenzio: meglio dirlo e uscire, che restare in uno stato a meta'.
      console.error('[ETHRO] non riesco a preparare il rinfresco del carrello', e);
      return;
    }

    sezioniRese
      .then(function (sezioniHtml) {
        return fetch(FoxTheme.routes.cart_url, Object.assign({}, FoxTheme.utils.fetchConfig()))
          .then(function (r) {
            return r.json();
          })
          .then(function (carrello) {
            carrello.sections = sezioniHtml;
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: carrello });
            if (apriIlCassetto) {
              var cassetto = document.querySelector('cart-drawer');
              if (cassetto && typeof cassetto.show === 'function') cassetto.show();
            }
          });
      })
      .catch(function (e) {
        console.error('[ETHRO] rinfresco del carrello fallito', e);
      });
  }

  var fetchOriginale = window.fetch;
  window.fetch = function (risorsa, opzioni) {
    var indirizzo = indirizzoDi(risorsa);
    var promessa = fetchOriginale.apply(this, arguments);

    if (!ROTTE.test(indirizzo)) return promessa;
    if (nostra(risorsa, opzioni)) return promessa;
    if (delTema(opzioni)) return promessa;

    var partita = Date.now();
    // Il cassetto si apre solo se dietro c'e' un gesto della persona: le app che
    // aggiungono di nascosto (un omaggio, un abbonamento) non devono spalancarlo
    // da sole. E sulla pagina carrello non ha senso in ogni caso.
    var apri = /\/cart\/add/.test(indirizzo) && Date.now() - ultimoTocco < 2000 && !suPaginaCarrello();

    return promessa.then(function (risposta) {
      if (risposta && risposta.ok) {
        setTimeout(function () {
          // Se nel frattempo il tema ha pubblicato lui, non tocchiamo niente:
          // il suo giro e' piu' ricco del nostro e rifarlo sopra sarebbe solo
          // uno sfarfallio.
          if (ultimoAggiornamento < partita) rinfresca(apri);
        }, ATTESA);
      }
      return risposta;
    });
  };
})();
